/* eslint-disable no-console */
// import {InfoCircleOutlined} from '@ant-design/icons';
import {Col, Flex, Row} from 'antd';
import React, {memo, useEffect, useState} from 'react';

import PieChart from '../../../../components/Chart/PieCharts/PieChart';
// import PieChartMulti from '../../../../components/Chart/PieCharts/PieChartMulti';
import RadialChart from '../../../../components/Chart/RadialChart/RadialChart';
// import {FacilityKey} from '../../../../components/Forms/Constants/IP/FacilityKeyLabel';
// import {filterSelectOptions} from '../../../../components/Forms/Utils/commonFunctions';
import Loader from '../../../../components/Loader/Loader';
import PageContent from '../../../../components/PageContent/PageContent';
import MainTableTitle from '../../../../components/Table/Utils/MainTableTitle';
// import {ISelect} from '../../../../interface/ISelect';
// import Tabs from '../../../../components/Tabs/Tabs';
// import {Itabs} from '../../../../interface/Tab';
// import listOfActivity from '../../../../services/modules/DASHBOARD/listOfActivity';
// import {getUniqueArray} from '../../../../shared/commonFunctions';
// import useJSONStore from '../../../../store/StaticJson/jsonStore';
// import {yearSelect} from '../../../../utils/FormUtils/yearSelect';
// import mapAndFilter from '../../../../utils/mapCountry';
import {accessModule} from '../../../../store/companyStore/companyDetailsStore';
import {shouldBlockModuleAccess} from '../../../../utils/SubscriptionHelper';
import TotalChartList from '../../../netZero/components/TotalChartList';
import {GHGEmissionConst} from '../../../netZero/generalized/constants/renderConstants';

import ChartWithLabel from './ChartWithLabel';
import {formatListOfActivity} from './constants/commonFunctions';
import Scope from './Scope';

// const tabItems: Itabs[] = allChart.map((item, index) => {
//   return {
//     id: `${index + 1}`,
//     name: item.tabLabel,
//     component: (
//       <ChartWithLabel
//         data={item.data}
//         title={item.title}
//         component={
//           <div style={{width: '100%', height: '400px'}}>
//             {item.chartType === 'Radial' ? (
//               <RadialChart data={item.data} />
//             ) : (
//               <PieChart data={item.data} />
//             )}
//           </div>
//         }
//       />
//     )
//   };
// });

const ListOfActivities: React.FC<{
  data: any;
}> = ({data}) => {
  // const [selCountry, setSelCountry] = useState<ISelect | undefined>(undefined);
  // const [selState, setSelState] = useState<ISelect | undefined>(undefined);
  // const [facility, setFacility] = useState(undefined);
  // const [mainData, setMainData] = useState<any>([]);
  const [renderData, setRenderData] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);

  // const {country, states} = useJSONStore.getState();

  useEffect(() => {
    setRenderData(
      formatListOfActivity(
        [...data?.facilityData, ...data?.companyData],
        shouldBlockModuleAccess(accessModule.scope3)
      ) ?? []
    );
    // setMainData([...data?.facilityData, ...data?.companyData]);
    setIsLoading(false);
  }, [data]);

  // useEffect(() => {
  //   setIsLoading(true);
  //   listOfActivity(selectedYear)
  //     .then((res) => {
  //       setRenderData(formatListOfActivity(res.data));
  //       setMainData(res.data);
  //       setIsLoading(false);
  //     })
  //     .catch(() => {
  //       setRenderData(formatListOfActivity([]));
  //       setIsLoading(false);
  //     });
  // }, [selectedYear]);

  // useEffect(() => {
  //   if (mainData?.length > 0) {
  //     let allValues = mainData;
  //     if (selCountry !== undefined) {
  //       allValues = allValues?.filter((item: any) => {
  //         return item.country === selCountry?.label;
  //       });
  //     }
  //     if (selState !== undefined) {
  //       allValues = allValues?.filter((item: any) => {
  //         return item.state === selState.label;
  //       });
  //     }
  //     if (facility !== undefined) {
  //       allValues = allValues?.filter((item: any) => {
  //         return item.facilityId === facility;
  //       });
  //     }
  //     setRenderData(formatListOfActivity(allValues));
  //   }
  // }, [selCountry, selState, facility]);

  const getScopeAccess = (scopeName: any) => {
    if (scopeName === 'scope1') {
      return accessModule.scope1;
    } else if (scopeName === 'scope2') {
      return accessModule.scope2;
    } else {
      return accessModule.scope3;
    }
  };

  return (
    <Flex className="LAContainerFlex">
      <Flex className="LAFlex">
        <div className="LATitle">List of Activities</div>
        {/* <div className="LARightDiv">
          <Select
            showSearch
            allowClear
            placeholder={'By Country'}
            defaultValue={selCountry}
            className="LAselect"
            value={selCountry}
            onChange={(_, record: any) => {
              setSelCountry(record ?? undefined);
              setSelState(undefined);
              setFacility(undefined);
            }}
            filterOption={filterSelectOptions}
            defaultActiveFirstOption={true}
            options={mapAndFilter(
              mainData,
              country,
              FacilityKey.COUNTRY,
              'label'
            )}
            popupMatchSelectWidth={false}
          />
          <Select
            allowClear
            placeholder={'By State'}
            defaultValue={selState}
            value={selState}
            className="LAselect"
            defaultActiveFirstOption={true}
            options={mapAndFilter(
              mainData,
              states?.filter((item) => {
                return selCountry?.value
                  ? item.country_id === selCountry?.value
                  : false;
              }),
              FacilityKey.STATE,
              'label'
            )}
            onChange={(_, record: any) => {
              setSelState(record);
              setFacility(undefined);
            }}
            popupMatchSelectWidth={false}
          />
          <Select
            showSearch
            allowClear
            placeholder={'By Facility'}
            defaultValue={facility}
            value={facility}
            className="LAselect"
            onChange={(value) => {
              setFacility(value);
            }}
            filterOption={filterSelectOptions}
            defaultActiveFirstOption={true}
            options={getUniqueArray(mainData, 'facilityId')
              ?.filter((item) => {
                return selCountry
                  ? selState
                    ? item.country === selCountry.label &&
                      item.state === selState.label
                    : item.country === selCountry.label
                  : false;
              })
              .map((item) => {
                return {label: item?.facilityName, value: item?.facilityId};
              })}
            popupMatchSelectWidth={false}
          />
          <InfoCircleOutlined />
        </div> */}
      </Flex>
      {isLoading ? (
        <Loader isHome />
      ) : (
        <Row gutter={[20, 20]} className="LARow">
          <Col span={12}>
            <PageContent>
              <Flex className="col1">
                <MainTableTitle title="Total Emissions" showDivider={false} />
                {/* <div className="allTabs">
                    <Tabs array={tabItems} noPadding={true} type="card" />
                  </div> */}
                {renderData.allChart.map((item: any, index: number) => {
                  return (
                    <div key={index} className="allTabs">
                      <ChartWithLabel
                        data={item.data}
                        title={'TOTAL EMISSIONS'}
                        component={
                          <div
                            style={{
                              width: '100%',
                              height: '400px',
                              marginTop: '10px'
                            }}
                          >
                            {item.chartType === 'Radial' ? (
                              <RadialChart data={item.data} />
                            ) : (
                              <PieChart data={item.data} />
                            )}
                          </div>
                        }
                      />
                    </div>
                  );
                })}
              </Flex>
            </PageContent>
          </Col>
          <Col span={12}>
            <PageContent>
              {/* <Flex className="col2">
                <MainTableTitle title="Carbon Emissions by Scope" />
                <div className="donutPieChart">
                  <PieChartMulti
                    data={GHG?.[0].data}
                    showLabel={true}
                    showLegend={true}
                    lessRound={true}
                  />
                </div>
              </Flex> */}
              <TotalChartList
                data={renderData.GHG}
                keyArray={GHGEmissionConst}
                chartType="donut"
                noBackground={true}
              />
            </PageContent>
          </Col>

          {renderData.SCOPE.map((item: any, index: number) => {
            return (
              <Col span={8} key={index}>
                <div className="col3">
                  <Scope
                    scopeData={item?.data}
                    scopeNumber={index + 1}
                    scopeColor={item?.scopeColor}
                    color={item?.color}
                    isBlock={shouldBlockModuleAccess(
                      getScopeAccess(`scope${index + 1}`)
                    )}
                  />
                </div>
              </Col>
            );
          })}
        </Row>
      )}
    </Flex>
  );
};

export default memo(ListOfActivities);
